import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Dialog, DialogContent, DialogTitle,  Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { RootState } from '../../../redux';

interface ISourceDetailsProps {
  field: any;
  open: boolean;
  setOpen: any;
}

const SourceDetails = ({ field, open, setOpen }: ISourceDetailsProps) => {
  const { tabTileProps } = useSelector((state: RootState) => {
    return {
      tabTileProps: state.tabTileProps,
    };
  });

  const selectedDs = tabTileProps.selectedDataSetList.find(
    (ds: any) => ds.id === field.originalDataSetId,
  );

  const table = useMemo(() => {
    if (selectedDs?.id) {
      return tabTileProps.tablesForSelectedDataSets[selectedDs?.id].find((table: any) => {
        return table.id === field?.originalTableId;
      });
    }
    return null;
  }, [selectedDs, field]);

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          flexDirection: 'row',
          columnGap: '2rem',
          justifyContent: 'space-between',
          fontSize: '16px',
          alignItems: 'center',
          padding: '12px 24px',
        }}
      >
        Source Details
        <Box sx={{ cursor: 'pointer' }} onClick={() => setOpen(false)}>
          <Close sx={{ fontSize: '16px' }} />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ padding: '16px 24px' }}>
        {table ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Typography variant="body1">
              <strong>Field Name:</strong> {field?.fieldname ?? field?.fieldName}
            </Typography>
            {(field?.displayname || field?.displayName) && (
              <Typography variant="body1">
                <strong>Display Name:</strong> {field?.displayname ?? field?.displayName}
              </Typography>
            )}
            <Typography variant="body1">
              <strong>Table Name:</strong> {table?.table}
            </Typography>
            <Typography variant="body1">
              <strong>Dataset Name:</strong> {selectedDs?.datasetName}
            </Typography>
            <Typography variant="body1">
              <strong>DB Connection:</strong> {selectedDs?.vendor}
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Typography variant="body1">The source is not available in the dataset.</Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SourceDetails;
